import * as React from 'react'
import './styles.css'
import '../Overview/styles.css'
import TrademarkText from '../../ui/TrademarkText'
import { ReactComponent as TalentPoolAndDecisionCards } from '../../../assets/imgs/overview/talentPool.svg'

const StrategicAlignment = () => {
  return (
    <section className='overview-section strategic-alignment-section'>
      <div className='box'>
        <div className='strategic-alignment-grid'>
          <div className='strategic-alignment-content'>
            <h2 className='strategic-alignment-title'>
              Turn Skills and Talent Into Strategic Alignment
            </h2>
            <p className='strategic-alignment-copy'>
              <TrademarkText>Pod Matching Engine™</TrademarkText> aligns people,
              skills, and opportunities across hiring, internal mobility,
              reskilling, and workforce planning - enabling precision talent
              decisions beyond traditional recruitment matching.
            </p>
            <p className='strategic-alignment-copy'>
              By analyzing real skills, organizational demand signals, and
              workforce pathways, the platform supports smarter alignment of
              talent to mission-critical roles and future capability needs.
            </p>
            <p className='strategic-alignment-caption'>
              Hiring | Internal Mobility | Reskilling | Workforce Planning
            </p>
          </div>

          <div className='strategic-alignment-visual overview-tile-container gradient-top-left box-relative-gradient'>
            <TalentPoolAndDecisionCards className='elements' />
          </div>
        </div>
      </div>
    </section>
  )
}

export default StrategicAlignment
